import Cookies from 'js-cookie';

export const ZG_SHOW_RENTER_DATA_MOCK_SECTIONS: boolean =
  typeof window !== 'undefined' ? Cookies.get('ZG_SHOW_RENTER_DATA_MOCK_SECTIONS') === 'true' : false;

export const ZG_BOOST_AD_PDF_EXPORT: boolean =
  typeof window !== 'undefined' ? Cookies.get('ZG_BOOST_AD_PDF_EXPORT') === 'true' : false;
